module.exports = __webpack_public_path__ + "img/icon_group.ece13022.png";